import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  justify-content: center;
  padding: 50px 20px;
`;

export const Content = styled.div`
  max-width: 1262px;
  width: 100%;

  h1 {
    font-size: 40px;
    text-align: center;
    color: #139ed5;
    font-family: "Noto Serif";
  }
`;

export const Cards = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
  gap: 10px;

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-items: center;

    :nth-child(1) {
      h3 {
        padding-bottom: 20px;
      }
    }
  }
`;

export const Card = styled.div`
  max-width: 246px;
  width: 100%;
  min-height: 236px;

  img {
    border-bottom: 5px solid #139ed5;
    border-radius: 10px;
    width: 100%;
  }

  h3 {
    text-align: center;
    color: #1d364a;
    font-size: 16px;
    font-family: "Noto Serif";
    padding: 5px;
  }
`;
